import React from 'react'

import { TContact } from '../../../common/validations/contractContacts'
import { useAPIGetContractContactsSuspense } from '../../api/apiHooks/useAPIGetContractContacts'

import { useCurrentContract } from 'hooks/useCurrentContract/useCurrentContract'

interface Data {
  contacts: TContact[]
}

export const ContactInfoDataLoader = ({
  children,
}: {
  children: (data: Data) => React.ReactNode
}) => {
  const { currentContractId } = useCurrentContract()
  const { data: contacts } =
    useAPIGetContractContactsSuspense(currentContractId)

  return children({ contacts })
}
